import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "px-4 py-0" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    key: 0,
    class: "mb-4"
};
const _hoisted_4 = {
    key: 1,
    class: "mb-4"
};
const _hoisted_5 = {
    key: 2,
    class: "mb-4"
};
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "mb-4" };
const _hoisted_8 = { key: 2 };
const _hoisted_9 = {
    key: 0,
    class: "mb-4"
};
const _hoisted_10 = { class: "fw-bold" };
const _hoisted_11 = { class: "mb-2" };
const _hoisted_12 = { key: 0 };
const _hoisted_13 = {
    key: 1,
    class: "mb-4 d-flex justify-content-between align-items-center"
};
const _hoisted_14 = { class: "mb-2" };
const _hoisted_15 = { class: "fw-bold" };
const _hoisted_16 = { key: 0 };
const _hoisted_17 = {
    key: 1,
    class: "d-block border-top mt-2"
};
const _hoisted_18 = { class: "mb-2" };
const _hoisted_19 = { class: "fw-bold" };
const _hoisted_20 = { key: 0 };
const _hoisted_21 = { class: "form-check form-switch mb-3" };
const _hoisted_22 = {
    class: "form-check-label",
    for: "taxPrices"
};
const _hoisted_23 = { class: "table-responsive mb-5" };
const _hoisted_24 = { class: "table table-hover align-middle" };
const _hoisted_25 = { scope: "col" };
const _hoisted_26 = { scope: "col" };
const _hoisted_27 = { scope: "col" };
const _hoisted_28 = { scope: "col" };
const _hoisted_29 = { scope: "row" };
const _hoisted_30 = { class: "row" };
const _hoisted_31 = { class: "col-12 col-lg-6 col-xl-8" };
const _hoisted_32 = {
    key: 0,
    class: "mb-4 me-0 me-lg-5"
};
const _hoisted_33 = { class: "fw-bold mb-5" };
const _hoisted_34 = { class: "mx-5" };
const _hoisted_35 = {
    class: "bg-light border border-2 rounded-3 p-0 w-100",
    style: { "overflow": "hidden" }
};
const _hoisted_36 = {
    class: "w-100 text-center bg-white py-3",
    style: { "height": "250px" }
};
const _hoisted_37 = ["src"];
const _hoisted_38 = { class: "p-2 d-flex flex-column justify-content-center" };
const _hoisted_39 = { class: "text-center fw-bold" };
const _hoisted_40 = {
    key: 0,
    class: "text-center fw-bold small"
};
const _hoisted_41 = { class: "text-center" };
const _hoisted_42 = { class: "p-2 d-flex justify-content-center" };
const _hoisted_43 = ["onClick"];
const _hoisted_44 = { class: "ms-2" };
const _hoisted_45 = { class: "col-12 col-lg-6 col-xl-4" };
const _hoisted_46 = { class: "table align-middle" };
const _hoisted_47 = { class: "d-block fw-bold" };
const _hoisted_48 = { class: "d-block small" };
const _hoisted_49 = { key: 0 };
const _hoisted_50 = { class: "fw-bold small" };
const _hoisted_51 = { key: 1 };
const _hoisted_52 = {
    key: 0,
    class: "form-floating"
};
const _hoisted_53 = ["value"];
const _hoisted_54 = { for: "deliveryType" };
const _hoisted_55 = {
    key: 1,
    class: "fw-bold"
};
const _hoisted_56 = { key: 2 };
const _hoisted_57 = { class: "d-block fw-bold" };
const _hoisted_58 = { class: "d-block small" };
const _hoisted_59 = { key: 3 };
const _hoisted_60 = { class: "fw-bold" };
const _hoisted_61 = { key: 4 };
const _hoisted_62 = { class: "fw-bold" };
const _hoisted_63 = {
    key: 5,
    class: "bg-light"
};
const _hoisted_64 = { class: "fs-5 text-primary" };
const _hoisted_65 = { class: "fs-5 text-primary fw-bold" };
const _hoisted_66 = { class: "ms-2" };
const _hoisted_67 = { key: 1 };
const _hoisted_68 = { class: "row mb-1" };
const _hoisted_69 = { class: "col-12 col-lg-6" };
const _hoisted_70 = { class: "fw-bold" };
const _hoisted_71 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_72 = {
    key: 1,
    class: "text-danger fw-bold"
};
const _hoisted_73 = { class: "col-12 col-lg-6" };
const _hoisted_74 = { class: "fw-bold" };
const _hoisted_75 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_76 = {
    key: 1,
    class: "text-danger fw-bold"
};
const _hoisted_77 = {
    key: 0,
    class: "mb-3 fw-bold small"
};
const _hoisted_78 = { class: "ms-2" };
const _hoisted_79 = {
    key: 2,
    class: "border-top pt-3"
};
const _hoisted_80 = {
    key: 0,
    class: "form-floating mb-3"
};
const _hoisted_81 = { for: "vatId" };
const _hoisted_82 = { class: "form-floating mb-3" };
const _hoisted_83 = ["placeholder"];
const _hoisted_84 = { for: "customerComment" };
const _hoisted_85 = { class: "form-floating" };
const _hoisted_86 = { for: "requestedDeliveryDate" };
const _hoisted_87 = { class: "form-text mb-3" };
const _hoisted_88 = { class: "form-floating mb-3" };
const _hoisted_89 = {
    value: "",
    selected: ""
};
const _hoisted_90 = ["value"];
const _hoisted_91 = { for: "cartQuestions" };
const _hoisted_92 = { class: "form-check mb-3" };
const _hoisted_93 = {
    class: "form-check-label",
    for: "newsletter"
};
const _hoisted_94 = { class: "form-check mb-3" };
const _hoisted_95 = {
    class: "form-check-label",
    for: "advertisingPurpose"
};
const _hoisted_96 = { class: "form-check mb-4" };
const _hoisted_97 = ["innerHTML"];
const _hoisted_98 = {
    key: 1,
    class: "fw-bold small"
};
const _hoisted_99 = { class: "fw-bold small" };
const _hoisted_100 = { class: "form-check mb-4" };
const _hoisted_101 = {
    class: "form-check-label",
    for: "paymentByBankTransfer"
};
const _hoisted_102 = ["disabled"];
const _hoisted_103 = { class: "ms-2" };
const _hoisted_104 = { key: 3 };
const _hoisted_105 = {
    key: 4,
    class: "d-flex justify-content-center",
    style: { "min-height": "400px" }
};
const _hoisted_106 = { class: "fw-bold d-flex align-items-center" };
const _hoisted_107 = { class: "ms-4" };
const _hoisted_108 = {
    key: 0,
    class: "mt-5 small"
};
import axios from 'axios';
import { onMounted, ref, watch } from 'vue';
import { observeDOMChanges, sendHeight } from '../Composables/iframeHeightCalculator';
import { cssStyleSheetLoader } from '../Composables/cssStyleSheetLoader';
import ConfiguratorLayout from '../Layouts/ConfiguratorLayout.vue';
import { useForm, usePage } from '@inertiajs/vue3';
import StandardLoadingDisplay from '@/Shared/StandardLoadingDisplay.vue';
import OrderPosition from '../Components/OrderPosition.vue';
import { Carousel } from 'primevue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import CartCustomerData from '../Components/CartCustomerData.vue';
import Swal from 'sweetalert2';
import { loadTenantConfigs } from '../Composables/standardFunctions';
import { useI18n } from 'vue-i18n';
import { useTrans } from '@/Composables/useTrans';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Cart',
    props: {
        tenantId: String,
        componentUuid: String,
        orderRequestUuid: String,
        currentOrderRequestUuid: {
            type: String,
            default: null
        },
        cssFileUrl: {
            type: String,
            default: null
        },
        configuratorUrl: {
            type: String,
            required: true
        },
        sessionId: {
            type: String,
            required: true
        },
        countries: {
            type: Object,
            required: true
        }
    },
    setup(__props) {
        let { loadCssStyleSheet } = cssStyleSheetLoader();
        let { showSuccessSwal, showErrorSwal } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const { t } = useI18n();
        const { trans } = useTrans();
        const props = __props;
        const cartKey = ref(Math.random().toString(36).substring(7));
        const user = ref(usePage().props.auth.user);
        const loading = ref(false);
        const orderRequest = ref();
        const productRecommendations = ref([]);
        const deliveryTypes = ref([]);
        const deliveryCountry = ref(null);
        const customerData = ref(null);
        const selectedDeliveryType = ref(null);
        const surveyAnswerOptions = ref([]);
        const showTaxIncludedPrices = ref(false);
        const showCustomerData = ref(false);
        const showOrderConfirmationDetails = ref(false);
        const replaceCartWithOrderRequest = ref(false);
        const imprintUrl = ref('');
        const privacyUrl = ref('');
        const tocUrl = ref('');
        const cancellationRightUrl = ref('');
        const tenantName = ref('');
        const checkoutForm = useForm({
            vatId: null,
            customerNotes: null,
            requestedDeliveryDate: null,
            cartQuestionUuid: surveyAnswerOptions.value.length > 0 ? surveyAnswerOptions.value[0].uuid : '',
            newsletter: false,
            advertisingPurpose: false,
            termsAndConditionsChecked: false,
            paymentByBankTransfer: false
        });
        const responsiveOptions = ref([
            {
                breakpoint: '1600px',
                numVisible: 1,
                numScroll: 1
            }
        ]);
        onMounted(async () => {
            if (props.cssFileUrl) {
                loadCssStyleSheet(props.cssFileUrl);
            }
            //load configs
            imprintUrl.value = await loadTenantConfigs('imprint_url');
            privacyUrl.value = await loadTenantConfigs('privacy_url');
            tocUrl.value = await loadTenantConfigs('toc_url');
            cancellationRightUrl.value = await loadTenantConfigs('cancellation_right_url');
            tenantName.value = await loadTenantConfigs('name');
            if (props.orderRequestUuid && props.currentOrderRequestUuid && props.orderRequestUuid !== props.currentOrderRequestUuid) {
                Swal.fire({
                    title: t('Möchten Sie das gewählte Angebot laden?'),
                    text: t('Ein bestehender Warenkorb wird durch das Angebot ersetzt.'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: t("Ja, Angebot laden"),
                    cancelButtonText: t("Nein, aktuellen Warenkorb behalten"),
                    confirmButtonColor: "#528399",
                    cancelButtonColor: "#dc3545",
                }).then((result) => {
                    if (result.isConfirmed) {
                        replaceCartWithOrderRequest.value = true;
                    }
                    else {
                        replaceCartWithOrderRequest.value = false;
                    }
                    loadCart();
                });
            }
            else {
                replaceCartWithOrderRequest.value = true;
                loadCart();
            }
            sendHeight();
            observeDOMChanges();
        });
        watch(selectedDeliveryType, (newValue) => {
            if (newValue) {
                loadCart();
            }
        });
        function loadCart() {
            loading.value = true;
            axios.post(route('cart.load', {
                tenantId: props.tenantId,
                // session_id: props.sessionId,
                order_request_uuid: props.orderRequestUuid && replaceCartWithOrderRequest.value ? props.orderRequestUuid : null,
                // component_uuid: props.componentUuid,
                delivery_type_uuid: selectedDeliveryType.value,
            }))
                .then(function (response) {
                loading.value = false;
                orderRequest.value = response.data.orderRequest;
                productRecommendations.value = response.data.productRecommendations;
                deliveryTypes.value = response.data.deliveryTypes;
                deliveryCountry.value = response.data.deliveryCountry;
                surveyAnswerOptions.value = response.data.surveyAnswerOptions;
                customerData.value = response.data.customerData;
                if (deliveryTypes.value && deliveryTypes.value.length > 0) {
                    selectedDeliveryType.value = deliveryTypes.value[0].uuid;
                }
                else {
                    selectedDeliveryType.value = null;
                }
                if (orderRequest.value.order && orderRequest.value.order.deliveryType) {
                    selectedDeliveryType.value = orderRequest.value.order.deliveryType.uuid;
                }
                cartKey.value = Math.random().toString(36).substring(7);
            })
                .catch(function (error) {
                loading.value = false;
                console.error(error);
            });
        }
        function addToCart(productId) {
            axios.post(route('cart.products.store', productId), {})
                .then(function (response) {
                loadCart();
            })
                .catch(function (error) {
                console.error(error);
            });
        }
        function createOrder() {
            Swal.fire({
                title: t("Weiterleitung zum Zahlungsanbieter") + " ...",
                icon: "info",
                timerProgressBar: true,
                showConfirmButton: false,
                background: '#fff',
                backdrop: '#fff',
                timer: 5000
            });
            axios.post(route('orders.store', orderRequest.value.uuid), {
                vat_id: checkoutForm.vatId,
                customer_notes: checkoutForm.customerNotes,
                requested_delivery_date: checkoutForm.requestedDeliveryDate,
                order_survey_answer_ids: checkoutForm.cartQuestionUuid ? [checkoutForm.cartQuestionUuid] : null,
                newsletter_abo: checkoutForm.newsletter ? 1 : 0,
                advertising_purpose: checkoutForm.advertisingPurpose ? 1 : 0,
                terms_and_conditions_checked: checkoutForm.termsAndConditionsChecked ? 1 : 0,
                delivery_type: selectedDeliveryType.value,
                component_uuid: props.componentUuid,
                payment_by_bank_transfer: checkoutForm.paymentByBankTransfer ? 1 : 0
            })
                .then(function (response) {
                showSuccessSwal(trans('Ihre Bestellung vom {date}'));
                if (response.data.checkoutUrl) {
                    if (window.top) {
                        window.top.location.href = response.data.checkoutUrl; //to ensure the redirect works in an iframe
                    }
                    else {
                        window.location.href = response.data.checkoutUrl;
                    }
                }
            })
                .catch(function (error) {
                console.error(error);
                showErrorSwal(t('Fehler bei der Verarbeitung Ihrer Bestellung, bitte führen Sie den Vorgang erneut durch.'));
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ConfiguratorLayout, null, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        (orderRequest.value && orderRequest.value.order == null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                (orderRequest.value == null || orderRequest.value && orderRequest.value.orderRequestTypeId == 1)
                                    ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_unref(t)('Warenkorb')), 1))
                                    : _createCommentVNode("", true),
                                (orderRequest.value && orderRequest.value.orderRequestTypeId == 2)
                                    ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_unref(t)('Ihre Anfrage')), 1))
                                    : _createCommentVNode("", true),
                                (orderRequest.value && orderRequest.value.orderRequestTypeId == 3)
                                    ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_unref(t)('Unser Angebot für Sie')), 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        (orderRequest.value && orderRequest.value.order)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("h1", _hoisted_7, _toDisplayString(_unref(trans)('Ihre Bestellung vom {date}', { date: _unref(formatDate)(orderRequest.value.order.createdAt) })), 1)
                            ]))
                            : _createCommentVNode("", true),
                        (orderRequest.value && !showCustomerData.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (orderRequest.value.customer && orderRequest.value.order == null)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createElementVNode("h5", _hoisted_10, _toDisplayString(_unref(t)('Rechnungsadresse')), 1),
                                        _createElementVNode("div", _hoisted_11, [
                                            _createTextVNode(_toDisplayString(orderRequest.value.customer.address ? orderRequest.value.customer.address.company : orderRequest.value.customer.company) + " ", 1),
                                            _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                                            _createTextVNode(_toDisplayString(orderRequest.value.customer.address ? orderRequest.value.customer.address.name : orderRequest.value.customer.name) + " ", 1),
                                            (orderRequest.value.customer.address)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                                    _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                                                    _createTextVNode(_toDisplayString(orderRequest.value.customer.address.street) + " ", 1),
                                                    _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                                                    _createTextVNode(_toDisplayString(orderRequest.value.customer.address.zipcode) + " " + _toDisplayString(orderRequest.value.customer.address.city) + " ", 1),
                                                    _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                                                    _createTextVNode(_toDisplayString(orderRequest.value.customer.address.country), 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (orderRequest.value.order)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("h5", _hoisted_15, _toDisplayString(_unref(t)('Rechnungsanschrift')), 1),
                                            _createTextVNode(" " + _toDisplayString(orderRequest.value.order.invoiceAddress ? orderRequest.value.order.invoiceAddress.company : orderRequest.value.customer.company) + " ", 1),
                                            _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                                            _createTextVNode(_toDisplayString(orderRequest.value.order.invoiceAddress ? orderRequest.value.order.invoiceAddress.name : orderRequest.value.customer.name) + " ", 1),
                                            (orderRequest.value.order.invoiceAddress)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                                    _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                                                    _createTextVNode(_toDisplayString(orderRequest.value.order.invoiceAddress.street) + " ", 1),
                                                    _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                                                    _createTextVNode(_toDisplayString(orderRequest.value.order.invoiceAddress.zipcode) + " " + _toDisplayString(orderRequest.value.order.invoiceAddress.city) + " ", 1),
                                                    _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                                                    _createTextVNode(_toDisplayString(orderRequest.value.order.invoiceAddress.country), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (orderRequest.value.order.customer)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                                    _createTextVNode(_toDisplayString(orderRequest.value.order.customer.email) + " ", 1),
                                                    _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                                                    _createTextVNode(_toDisplayString(orderRequest.value.order.customer.phone), 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_18, [
                                            _createElementVNode("h5", _hoisted_19, _toDisplayString(_unref(t)('Lieferanschrift')), 1),
                                            _createTextVNode(" " + _toDisplayString(orderRequest.value.order.deliveryAddress ? orderRequest.value.order.deliveryAddress.company : orderRequest.value.customer.company) + " ", 1),
                                            _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                                            _createTextVNode(_toDisplayString(orderRequest.value.order.deliveryAddress ? orderRequest.value.order.deliveryAddress.name : orderRequest.value.customer.name) + " ", 1),
                                            (orderRequest.value.order.deliveryAddress)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                                    _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                                                    _createTextVNode(_toDisplayString(orderRequest.value.order.deliveryAddress.street) + " ", 1),
                                                    _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                                                    _createTextVNode(_toDisplayString(orderRequest.value.order.deliveryAddress.zipcode) + " " + _toDisplayString(orderRequest.value.order.deliveryAddress.city) + " ", 1),
                                                    _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                                                    _createTextVNode(_toDisplayString(orderRequest.value.order.deliveryAddress.country), 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_21, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        role: "switch",
                                        id: "taxPrices",
                                        value: "1",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((showTaxIncludedPrices).value = $event))
                                    }, null, 512), [
                                        [_vModelCheckbox, showTaxIncludedPrices.value]
                                    ]),
                                    _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(t)('Preise inkl. MwSt. anzeigen')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("table", _hoisted_24, [
                                        _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                                _cache[27] || (_cache[27] = _createElementVNode("th", { scope: "col" }, "#", -1)),
                                                _createElementVNode("th", _hoisted_25, _toDisplayString(_unref(t)('Produkt')), 1),
                                                _createElementVNode("th", _hoisted_26, _toDisplayString(_unref(t)('Stückpreis')), 1),
                                                _createElementVNode("th", _hoisted_27, _toDisplayString(_unref(t)('Menge')), 1),
                                                _createElementVNode("th", _hoisted_28, _toDisplayString(_unref(t)('Gesamt')), 1),
                                                _cache[28] || (_cache[28] = _createElementVNode("th", { scope: "col" }, null, -1))
                                            ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderRequest.value.orderPositions, (positionUuid, index) => {
                                                return (_openBlock(), _createElementBlock("tr", null, [
                                                    _createElementVNode("th", _hoisted_29, _toDisplayString(index + 1), 1),
                                                    (_openBlock(), _createBlock(OrderPosition, {
                                                        orderPositionUuid: positionUuid,
                                                        taxIncluded: showTaxIncludedPrices.value,
                                                        configuratorUrl: props.configuratorUrl,
                                                        canChange: orderRequest.value.order == null,
                                                        onUpdate: loadCart,
                                                        onRemove: loadCart,
                                                        key: cartKey.value
                                                    }, null, 8, ["orderPositionUuid", "taxIncluded", "configuratorUrl", "canChange"]))
                                                ]));
                                            }), 256))
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                        (productRecommendations.value.length > 0 && orderRequest.value.order == null)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                _createElementVNode("h3", _hoisted_33, _toDisplayString(_unref(t)('Unsere Empfehlung für Sie')), 1),
                                                _createVNode(_unref(Carousel), {
                                                    value: productRecommendations.value,
                                                    numVisible: 4,
                                                    numScroll: 1,
                                                    responsiveOptions: responsiveOptions.value,
                                                    showIndicators: false,
                                                    showNavigators: true
                                                }, {
                                                    item: _withCtx((slotProps) => [
                                                        _createElementVNode("div", _hoisted_34, [
                                                            _createElementVNode("div", _hoisted_35, [
                                                                _createElementVNode("div", _hoisted_36, [
                                                                    _createElementVNode("img", {
                                                                        src: slotProps.data.image,
                                                                        class: "h-100"
                                                                    }, null, 8, _hoisted_37)
                                                                ]),
                                                                _createElementVNode("div", _hoisted_38, [
                                                                    _createElementVNode("span", _hoisted_39, _toDisplayString(slotProps.data.name), 1),
                                                                    (slotProps.data.volume)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(slotProps.data.volume), 1))
                                                                        : _createCommentVNode("", true),
                                                                    _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(t)('ab')) + " " + _toDisplayString(_unref(formatCurrency)(slotProps.data.startPrice)), 1)
                                                                ]),
                                                                _createElementVNode("div", _hoisted_42, [
                                                                    _createElementVNode("button", {
                                                                        class: "btn btn-primary rounded-5 d-flex align-items-center",
                                                                        onClick: ($event) => (addToCart(slotProps.data.id))
                                                                    }, [
                                                                        _cache[29] || (_cache[29] = _createElementVNode("svg", {
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            width: "16",
                                                                            height: "16",
                                                                            fill: "currentColor",
                                                                            class: "bi bi-cart-plus",
                                                                            viewBox: "0 0 16 16"
                                                                        }, [
                                                                            _createElementVNode("path", { d: "M9 5.5a.5.5 0 0 0-1 0V7H6.5a.5.5 0 0 0 0 1H8v1.5a.5.5 0 0 0 1 0V8h1.5a.5.5 0 0 0 0-1H9z" }),
                                                                            _createElementVNode("path", { d: "M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zm3.915 10L3.102 4h10.796l-1.313 7zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" })
                                                                        ], -1)),
                                                                        _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(t)('In den Warenkorb')), 1)
                                                                    ], 8, _hoisted_43)
                                                                ])
                                                            ])
                                                        ])
                                                    ]),
                                                    _: 1
                                                }, 8, ["value", "responsiveOptions"])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("table", _hoisted_46, [
                                            _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("td", null, _toDisplayString(_unref(t)('Zwischensumme')), 1),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(formatCurrency)(orderRequest.value.subTotalPrice)), 1),
                                                        _createElementVNode("span", _hoisted_48, _toDisplayString(_unref(t)('exkl. MwSt.')), 1)
                                                    ])
                                                ]),
                                                (customerData.value.invoiceCountry == null && orderRequest.value.order == null)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_49, [
                                                        _createElementVNode("td", null, _toDisplayString(_unref(t)('Versand')), 1),
                                                        _createElementVNode("td", _hoisted_50, _toDisplayString(_unref(t)('Die Lieferart und Versandkosten können erst nach Auswahl der Lieferadresse festgelegt werden.')), 1)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (customerData.value.invoiceCountry || orderRequest.value.order)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_51, [
                                                        _createElementVNode("td", null, _toDisplayString(_unref(t)('Versandart')), 1),
                                                        _createElementVNode("td", null, [
                                                            (orderRequest.value.order == null)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                                    _withDirectives(_createElementVNode("select", {
                                                                        class: "form-select",
                                                                        id: "deliveryType",
                                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedDeliveryType).value = $event)),
                                                                        required: ""
                                                                    }, [
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliveryTypes.value, (deliveryType) => {
                                                                            return (_openBlock(), _createElementBlock("option", {
                                                                                value: deliveryType.uuid
                                                                            }, _toDisplayString(deliveryType.name), 9, _hoisted_53));
                                                                        }), 256))
                                                                    ], 512), [
                                                                        [_vModelSelect, selectedDeliveryType.value]
                                                                    ]),
                                                                    _createElementVNode("label", _hoisted_54, _toDisplayString(_unref(t)('Lieferart')), 1)
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            (orderRequest.value.order)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(orderRequest.value.order.deliveryType.name), 1))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (customerData.value.invoiceCountry || orderRequest.value.order)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_56, [
                                                        _createElementVNode("td", null, _toDisplayString(_unref(t)('Versandkosten')) + " (" + _toDisplayString((orderRequest.value.totalWeight / 1000).toFixed(2)) + " kg)", 1),
                                                        _createElementVNode("td", null, [
                                                            _createElementVNode("span", _hoisted_57, _toDisplayString(_unref(formatCurrency)(orderRequest.value.deliveryPrice)), 1),
                                                            _createElementVNode("span", _hoisted_58, _toDisplayString(_unref(t)('exkl. MwSt.')), 1)
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (orderRequest.value.deliveryDays && orderRequest.value.deliveryDays > 0)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_59, [
                                                        _createElementVNode("td", null, _toDisplayString(_unref(t)('Lieferzeit')), 1),
                                                        _createElementVNode("td", null, "ca. " + _toDisplayString(orderRequest.value.deliveryDays) + " Tage", 1)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("tr", {
                                                    class: _normalizeClass({ 'bg-light': !orderRequest.value.showTaxes })
                                                }, [
                                                    _createElementVNode("th", null, _toDisplayString(_unref(t)('Gesamtsumme ohne MwSt.')), 1),
                                                    _createElementVNode("td", _hoisted_60, _toDisplayString(_unref(formatCurrency)(orderRequest.value.totalPrice)), 1)
                                                ], 2),
                                                (orderRequest.value.showTaxes)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_61, [
                                                        _createElementVNode("td", null, _toDisplayString(_unref(trans)('zzgl. {taxRate} % MwSt.', { taxRate: orderRequest.value.taxRate })), 1),
                                                        _createElementVNode("td", _hoisted_62, _toDisplayString(_unref(formatCurrency)(orderRequest.value.totalTax)), 1)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (orderRequest.value.showTaxes)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_63, [
                                                        _createElementVNode("th", _hoisted_64, _toDisplayString(_unref(t)('Gesamtsumme inkl. MwSt.')), 1),
                                                        _createElementVNode("td", _hoisted_65, _toDisplayString(_unref(formatCurrency)(orderRequest.value.totalPriceInclTax)), 1)
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]),
                                        (!showOrderConfirmationDetails.value && orderRequest.value.order == null)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "btn btn-primary rounded-5 d-flex align-items-center",
                                                onClick: _cache[2] || (_cache[2] = ($event) => { showCustomerData.value = true; showOrderConfirmationDetails.value = true; })
                                            }, [
                                                _cache[30] || (_cache[30] = _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-check2-circle",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" }),
                                                    _createElementVNode("path", { d: "M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" })
                                                ], -1)),
                                                _createElementVNode("span", _hoisted_66, _toDisplayString(_unref(t)('zum Bestellabschluss')), 1)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (showOrderConfirmationDetails.value && orderRequest.value.order == null)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                                _createElementVNode("div", _hoisted_68, [
                                                    _createElementVNode("div", _hoisted_69, [
                                                        _createElementVNode("p", _hoisted_70, _toDisplayString(_unref(t)('Rechnungsanschrift')), 1),
                                                        (customerData.value && customerData.value.invoiceFirstname)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                                                _createTextVNode(_toDisplayString(customerData.value.invoiceCompany), 1),
                                                                _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
                                                                _createTextVNode(_toDisplayString(customerData.value.invoiceFirstname) + " " + _toDisplayString(customerData.value.invoiceLastname), 1),
                                                                _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
                                                                _createTextVNode(_toDisplayString(customerData.value.invoiceStreet), 1),
                                                                _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
                                                                _createTextVNode(_toDisplayString(customerData.value.invoiceZipcode) + " " + _toDisplayString(customerData.value.invoiceCity), 1),
                                                                _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
                                                                _createTextVNode(_toDisplayString(customerData.value.invoiceCountryName), 1)
                                                            ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_unref(t)('Bitte geben Sie eine Rechnungsanschrift an')), 1))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_73, [
                                                        _createElementVNode("p", _hoisted_74, _toDisplayString(_unref(t)('Lieferanschrift')), 1),
                                                        (customerData.value && customerData.value.deliveryFirstname)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                                                _createTextVNode(_toDisplayString(customerData.value.deliveryCompany), 1),
                                                                _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
                                                                _createTextVNode(_toDisplayString(customerData.value.deliveryFirstname) + " " + _toDisplayString(customerData.value.deliveryLastname), 1),
                                                                _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
                                                                _createTextVNode(_toDisplayString(customerData.value.deliveryStreet), 1),
                                                                _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
                                                                _createTextVNode(_toDisplayString(customerData.value.deliveryZipcode) + " " + _toDisplayString(customerData.value.deliveryCity), 1),
                                                                _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
                                                                _createTextVNode(_toDisplayString(customerData.value.deliveryCountryName), 1)
                                                            ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(_unref(t)('Bitte geben Sie eine Lieferanschrift an')), 1))
                                                    ])
                                                ]),
                                                (orderRequest.value.order == null)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_77, _toDisplayString(_unref(t)('Auch wenn Ihre Anfrage oder Angebot eine andere Rechnungs- oder Lieferadresse enthält, können Sie diese hier für die Bestellung nochmal anpassen.')), 1))
                                                    : _createCommentVNode("", true),
                                                (orderRequest.value.order == null)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        class: "btn btn-secondary btn-sm d-flex align-items-center mb-3",
                                                        onClick: _cache[3] || (_cache[3] = ($event) => (showCustomerData.value = true))
                                                    }, [
                                                        _cache[39] || (_cache[39] = _createElementVNode("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            width: "16",
                                                            height: "16",
                                                            fill: "currentColor",
                                                            class: "bi bi-pencil-square",
                                                            viewBox: "0 0 16 16"
                                                        }, [
                                                            _createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
                                                            _createElementVNode("path", {
                                                                "fill-rule": "evenodd",
                                                                d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                                            })
                                                        ], -1)),
                                                        _createElementVNode("span", _hoisted_78, _toDisplayString(_unref(t)('ändern')), 1)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (orderRequest.value.order == null)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                                        _createElementVNode("form", {
                                                            onSubmit: _withModifiers(createOrder, ["prevent"])
                                                        }, [
                                                            (orderRequest.value.requiresVat)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        type: "text",
                                                                        class: "form-control",
                                                                        id: "vatId",
                                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(checkoutForm).vatId) = $event)),
                                                                        required: ""
                                                                    }, null, 512), [
                                                                        [_vModelText, _unref(checkoutForm).vatId]
                                                                    ]),
                                                                    _createElementVNode("label", _hoisted_81, _toDisplayString(_unref(t)('Umsatzsteuer-ID/VAT-ID')), 1)
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            _createElementVNode("div", _hoisted_82, [
                                                                _withDirectives(_createElementVNode("textarea", {
                                                                    class: "form-control",
                                                                    placeholder: _unref(t)('Möchten Sie uns noch etwas mitteilen'),
                                                                    id: "customerComment",
                                                                    style: { "height": "100px" },
                                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(checkoutForm).customerNotes) = $event))
                                                                }, null, 8, _hoisted_83), [
                                                                    [_vModelText, _unref(checkoutForm).customerNotes]
                                                                ]),
                                                                _createElementVNode("label", _hoisted_84, _toDisplayString(_unref(t)('Möchten Sie uns noch etwas mitteilen')), 1)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_85, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    type: "date",
                                                                    class: "form-control",
                                                                    id: "requestedDeliveryDate",
                                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(checkoutForm).requestedDeliveryDate) = $event))
                                                                }, null, 512), [
                                                                    [_vModelText, _unref(checkoutForm).requestedDeliveryDate]
                                                                ]),
                                                                _createElementVNode("label", _hoisted_86, _toDisplayString(_unref(t)('Gewünschtes Lieferdatum')), 1)
                                                            ]),
                                                            _createElementVNode("p", _hoisted_87, _toDisplayString(_unref(t)('Sie können uns optional ein gewünschtes Lieferdatum mitteilen. Bitte beachten Sie, dass eine min. Lieferzeit von 14 Tagen einzuplanen ist. Ihr gewünschter Liefertermin wird von uns explizit bestätigt oder korrigiert.')), 1),
                                                            _createElementVNode("div", _hoisted_88, [
                                                                _withDirectives(_createElementVNode("select", {
                                                                    class: "form-select",
                                                                    id: "cartQuestions",
                                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(checkoutForm).cartQuestionUuid) = $event))
                                                                }, [
                                                                    _createElementVNode("option", _hoisted_89, _toDisplayString(_unref(t)('Keine Angabe')), 1),
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(surveyAnswerOptions.value, (option) => {
                                                                        return (_openBlock(), _createElementBlock("option", {
                                                                            value: option.uuid
                                                                        }, _toDisplayString(option.name), 9, _hoisted_90));
                                                                    }), 256))
                                                                ], 512), [
                                                                    [_vModelSelect, _unref(checkoutForm).cartQuestionUuid]
                                                                ]),
                                                                _createElementVNode("label", _hoisted_91, _toDisplayString(_unref(trans)('Wie sind Sie auf {name} aufmerksam geworden?', { name: tenantName.value })), 1)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_92, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    class: "form-check-input",
                                                                    type: "checkbox",
                                                                    value: "1",
                                                                    id: "newsletter",
                                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(checkoutForm).newsletter) = $event))
                                                                }, null, 512), [
                                                                    [_vModelCheckbox, _unref(checkoutForm).newsletter]
                                                                ]),
                                                                _createElementVNode("label", _hoisted_93, _toDisplayString(_unref(t)('Newsletter abonnieren')), 1)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_94, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    class: "form-check-input",
                                                                    type: "checkbox",
                                                                    value: "1",
                                                                    id: "advertisingPurpose",
                                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(checkoutForm).advertisingPurpose) = $event))
                                                                }, null, 512), [
                                                                    [_vModelCheckbox, _unref(checkoutForm).advertisingPurpose]
                                                                ]),
                                                                _createElementVNode("label", _hoisted_95, _toDisplayString(_unref(trans)('Ich bin damit einverstanden, dass mein konfiguriertes Layout für Werbezwecke von Seiten {name} genutzt werden darf. Dieser Zustimmung kann ich jederzeit widersprechen.', { name: tenantName.value })), 1)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_96, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    class: "form-check-input",
                                                                    type: "checkbox",
                                                                    value: "1",
                                                                    id: "agb",
                                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(checkoutForm).termsAndConditionsChecked) = $event)),
                                                                    required: ""
                                                                }, null, 512), [
                                                                    [_vModelCheckbox, _unref(checkoutForm).termsAndConditionsChecked]
                                                                ]),
                                                                _createElementVNode("label", {
                                                                    class: "form-check-label",
                                                                    for: "agb",
                                                                    innerHTML: _unref(trans)('Ich habe die {tocUrlT}, die {privacyUrlT} und die {cancellationRightUrlT} gelesen und bin damit einverstanden.', {
                                                                        tocUrlT: `<a href='${tocUrl.value}'>${_unref(t)('AGBs')}</a>`,
                                                                        privacyUrlT: `<a href='${privacyUrl.value}'>${_unref(t)('Datenschutzerklärung')}</a>`,
                                                                        cancellationRightUrlT: `<a href='${cancellationRightUrl.value}'>${_unref(t)('Widerrufsbelehrung')}</a>`
                                                                    })
                                                                }, null, 8, _hoisted_97)
                                                            ]),
                                                            (!_unref(checkoutForm).paymentByBankTransfer)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_98, _toDisplayString(_unref(t)('Sie werden für den Zahlungsvorgang zu unserem Zahlungspartner STRIPE weitergeleitet.')), 1))
                                                                : _createCommentVNode("", true),
                                                            _cache[41] || (_cache[41] = _createElementVNode("hr", null, null, -1)),
                                                            _createElementVNode("p", _hoisted_99, _toDisplayString(_unref(t)('Bitte prüfen Sie vor Abschluss der Bestellung nochmals alle Angaben.')), 1),
                                                            _createElementVNode("div", _hoisted_100, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    class: "form-check-input",
                                                                    type: "checkbox",
                                                                    value: "1",
                                                                    id: "paymentByBankTransfer",
                                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(checkoutForm).paymentByBankTransfer) = $event))
                                                                }, null, 512), [
                                                                    [_vModelCheckbox, _unref(checkoutForm).paymentByBankTransfer]
                                                                ]),
                                                                _createElementVNode("label", _hoisted_101, _toDisplayString(_unref(t)('Ich möchte per Überweisung auf Rechnung bezahlen.')), 1)
                                                            ]),
                                                            _createElementVNode("button", {
                                                                type: "submit",
                                                                class: "btn btn-primary rounded-5 d-flex align-items-center",
                                                                disabled: customerData.value == null
                                                            }, [
                                                                _cache[40] || (_cache[40] = _createElementVNode("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    width: "16",
                                                                    height: "16",
                                                                    fill: "currentColor",
                                                                    class: "bi bi-check2-circle",
                                                                    viewBox: "0 0 16 16"
                                                                }, [
                                                                    _createElementVNode("path", { d: "M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" }),
                                                                    _createElementVNode("path", { d: "M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" })
                                                                ], -1)),
                                                                _createElementVNode("span", _hoisted_103, _toDisplayString(_unref(t)('Zahlungspflichtig bestellen')), 1)
                                                            ], 8, _hoisted_102)
                                                        ], 32)
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (showCustomerData.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                _createVNode(CartCustomerData, {
                                    tenantId: props.tenantId,
                                    orderRequestUuid: orderRequest.value.uuid,
                                    countries: props.countries,
                                    onUpdate: _cache[12] || (_cache[12] = ($event) => { showCustomerData.value = false; loadCart(); }),
                                    onClose: _cache[13] || (_cache[13] = ($event) => { showCustomerData.value = false; })
                                }, null, 8, ["tenantId", "orderRequestUuid", "countries"])
                            ]))
                            : _createCommentVNode("", true),
                        (orderRequest.value == null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                _createElementVNode("h4", _hoisted_106, [
                                    _cache[42] || (_cache[42] = _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        height: "40",
                                        fill: "currentColor",
                                        class: "bi bi-emoji-frown",
                                        viewBox: "0 0 16 16"
                                    }, [
                                        _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                        _createElementVNode("path", { d: "M4.285 12.433a.5.5 0 0 0 .683-.183A3.5 3.5 0 0 1 8 10.5c1.295 0 2.426.703 3.032 1.75a.5.5 0 0 0 .866-.5A4.5 4.5 0 0 0 8 9.5a4.5 4.5 0 0 0-3.898 2.25.5.5 0 0 0 .183.683M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5m4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5" })
                                    ], -1)),
                                    _createElementVNode("span", _hoisted_107, _toDisplayString(_unref(t)('Ihr Warenkorb ist noch leer.')), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (loading.value)
                            ? (_openBlock(), _createBlock(StandardLoadingDisplay, {
                                key: 5,
                                infoText: _unref(t)('Warenkorb wird geladen')
                            }, null, 8, ["infoText"]))
                            : _createCommentVNode("", true)
                    ]),
                    (user.value && !user.value.isCustomer)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_108, _toDisplayString(props.sessionId), 1))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
